import type { ProjectBadgeColor } from '@flowqa/shared';

export const defaultProjectBadgeColor: ProjectBadgeColor = 'teal';
export const projectBadgeCharsMaxLength = 2;

export const projectBadgeColorOptions: Array<{ value: ProjectBadgeColor; swatch: string }> = [
  { value: 'neutral', swatch: '#5F6670' },
  { value: 'green', swatch: '#2E7D32' },
  { value: 'orange', swatch: '#A04700' },
  { value: 'red', swatch: '#B3261E' },
  { value: 'blue', swatch: '#1565C0' },
  { value: 'purple', swatch: '#7B1FA2' },
  { value: 'teal', swatch: '#006C78' },
  { value: 'brown', swatch: '#6D4C41' },
];

const stripBadgeChars = (value: string): string =>
  value
    .replace(/[^a-z0-9]/gi, '')
    .toUpperCase()
    .slice(0, projectBadgeCharsMaxLength);

export const deriveProjectBadgeChars = (name: string): string => {
  const trimmed = name.trim();
  if (trimmed.length === 0) return 'P';

  const firstWord = trimmed.split(/\s+/)[0] ?? trimmed;
  const normalized = stripBadgeChars(firstWord);
  return normalized || 'P';
};

export const normalizeProjectBadgeChars = (value: string): string => stripBadgeChars(value);

export const getRandomProjectBadgeColor = (): ProjectBadgeColor => {
  const randomIndex = Math.floor(Math.random() * projectBadgeColorOptions.length);
  return projectBadgeColorOptions[randomIndex]?.value ?? defaultProjectBadgeColor;
};

export const resolveProjectBadgeSwatch = (color: ProjectBadgeColor): string =>
  projectBadgeColorOptions.find((option) => option.value === color)?.swatch ??
  projectBadgeColorOptions.find((option) => option.value === defaultProjectBadgeColor)?.swatch ??
  '#006C78';
